import { ListenerEffectAPI, ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';
import { fetchSync, removeUser } from '../sync/sync';

const logoutHandler = (listenerApi: ListenerEffectAPI<unknown, ThunkDispatch<unknown, unknown, UnknownAction>, unknown>, payload: any) => {
  listenerApi.dispatch(removeUser());
  listenerApi.dispatch(fetchSync());
}

export default logoutHandler;
